import * as z from "zod";
import { OC } from "../../utils";
import { AdminAgency } from "./schema";

export const agencyContract = OC.router({
  get: OC.output(AdminAgency.Agency.omit({ ownerId: true })),
  getPrivateKey: OC.meta({ permissions: ["nationalId:get"] }).output(
    AdminAgency.AgencyPrivateKey,
  ),
  create: OC.meta({
    alters: true,
    auditLog: { modelName: "AGENCY", action: "CREATE" },
    aragon: "agency_created",
  })
    .input(
      AdminAgency.Create.safeExtend({
        logo: z
          .instanceof(File)
          .refine(
            (file) =>
              ["image/jpeg", "image/png", "image/webp"].includes(file.type),
            {
              message: "Logo must be a JPEG, PNG, or WebP",
            },
          )
          .refine(
            (file) => file.size <= 10 * 1024 ** 2,
            "Logo must be less than 10MB",
          )
          .nullish(),
      }),
    )
    .output(AdminAgency.Agency),
  update: OC.meta({
    alters: true,
    auditLog: { modelName: "AGENCY", action: "UPDATE" },
    aragon: "agency_updated",
    permissions: true,
  })
    .input(
      AdminAgency.Update.safeExtend({
        logo: z
          .instanceof(File)
          .refine(
            (file) =>
              ["image/jpeg", "image/png", "image/webp"].includes(file.type),
            {
              message: "Logo must be a JPEG, PNG, or WebP",
            },
          )
          .refine(
            (file) => file.size <= 10 * 1024 ** 2,
            "Logo must be less than 10MB",
          )
          .nullish(),
      }),
    )
    .output(AdminAgency.Agency),
  checkUsernameAvailable: OC.input(
    z.object({ username: z.string().toUpperCase() }),
  ).output(z.boolean()),
});
